import { useContext } from "react"
import { UserContext } from "../contexts/UserContext"

export const useUserData = () => {
    const {
        token
        ,setToken
        ,password
        ,setPassword
        ,email
        ,setEmail
        ,lang
        ,setLang
        ,isAuthenticated
        ,setIsAuthenticated
        ,stripeSubscription
    } = useContext(UserContext);

    return {
        token
        ,setToken
        ,password
        ,setPassword
        ,email
        ,setEmail
        ,lang
        ,setLang
        ,isAuthenticated
        ,setIsAuthenticated
        ,stripeSubscription
    }
}